import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import queryString from "query-string";
import { withRouter } from "react-router-dom";
import DateRange from "../../Components/DateRange";
import BackendClient, { encodeBody } from "../../BackendClient";
import SummaryList from "./_list";

// import Select from "react-select";
// import { ValueContainer } from "../../Components/Select";
import DateFormat from "../../helpers/DateFormat";

const mapStateToProps = ({ identity }) => ({
    identity
});

class ReportsSummary extends Component {
    state = {
        filters: {},
        reportGroup: [],
        isNoticeVisible: true,
    };

    componentDidMount() {
        const { dateBegin, dateEnd } = queryString.parse(
            this.props.location.search,
            {
                decode: true,
                arrayFormat: "none"
            }
        );
        const { theatreId, theatreCityId } = this.props.identity;

        if (theatreId) {
            this.updateLink({ theatre: theatreId, city: theatreCityId, dateBegin, dateEnd });
        }
    }

    componentDidUpdate() {
        let { filters: stateFilters } = this.state;
        const parsedFilters = {};
        const { city, theatre, dateBegin, dateEnd } = queryString.parse(
            this.props.location.search,
            {
                decode: true,
                arrayFormat: "none"
            }
        );

        if (city) {
            stateFilters.city !== city && Object.assign(parsedFilters, { city });
        }

        if (theatre) {
            stateFilters.theatre !== theatre && Object.assign(parsedFilters, { theatre });
        }

        if (dateBegin) {
            if (
                !stateFilters.dateBegin ||
                stateFilters.dateBegin.ddmmyyyy() !== dateBegin
            ) {
                const dtBegin = this.strToDate(dateBegin);
                dtBegin && Object.assign(parsedFilters, { dateBegin: dtBegin });
            }
        } else if (stateFilters.dateBegin) {
            Object.assign(parsedFilters, { dateBegin: null });
        }

        if (dateEnd) {
            if (
                !stateFilters.dateEnd ||
                stateFilters.dateEnd.ddmmyyyy() !== dateEnd
            ) {
                const dtEnd = this.strToDate(dateEnd);
                dtEnd && Object.assign(parsedFilters, { dateEnd: dtEnd });
            }
        } else if (stateFilters.dateEnd) {
            Object.assign(parsedFilters, { dateEnd: null });
        }

        const hasNewFilters = !!Object.entries(parsedFilters).length;
        const filters = hasNewFilters
            ? Object.assign(stateFilters, parsedFilters)
            : stateFilters;

        if (hasNewFilters) {
            let reportParams = this.getReportParams(filters);
            BackendClient.getReports(reportParams)
                .fetchJson()
                .then(reportGroup => this.setState({ reportGroup, filters }));
        }
    }

    strToDate = str => {
        let pattern = /(\d{2})\.(\d{2})\.(\d{4})/;
        return new Date(str.replace(pattern, "$3-$2-$1"));
    };

    getRange() {
        let { filters: { dateBegin, dateEnd } } = this.state;
        if (dateBegin && dateEnd) {
            return { dateBegin, dateEnd };
        }
        return {
            dateBegin: new Date(2018, 4, 1),
            dateEnd: new Date(2018, 4, 7)
        };
    }

    getDates() {
        const { dateBegin, dateEnd } = this.getRange();
        const range = [];
        range.push(dateBegin.getTime());
        range.push(dateEnd.getTime());
        return range;
    }

    getDateRanges = () => {
        let { dateBegin, dateEnd } = this.state.filters

        if (!dateBegin || !dateEnd) {
            let range = this.getRange();
            dateBegin = range.dateBegin
            dateEnd = range.dateEnd
        }

        let dateArray = [];
        let currentDate = dateBegin;

        while (currentDate <= dateEnd) {
            dateArray.push({
                key: new Date(currentDate).ddmmyyyy(),
                value: new Date(currentDate).ddMM()
            });
            currentDate = currentDate.addDays(1);
        }
        return dateArray;
    };

    getReportParams = filters => {
        let reportParams = {}
        let { dateBegin, dateEnd } = this.getRange();
        if (filters.dateBegin) {
            reportParams.dateBegin = filters.dateBegin.ddmmyyyy();
        }
        if (filters.dateEnd) {
            reportParams.dateEnd = filters.dateEnd.ddmmyyyy();
        }
        if (filters.city) {
            reportParams.city = filters.city;
        }
        if (filters.theatre) {
            reportParams.theatre = filters.theatre;
        }

        if (!reportParams.dateBegin) {
            reportParams.dateBegin = dateBegin.ddmmyyyy()
        }
        if (!reportParams.dateEnd) {
            reportParams.dateEnd = dateEnd.ddmmyyyy()
        }

        return reportParams;
    }

    dateRangeFilterOnChange = ({ startDate, endDate }) => {
        this.updateLink({
            dateBegin: startDate.ddmmyyyy(),
            dateEnd: endDate.ddmmyyyy()
        });
    };

    createReportLink = (date, cityId, cinemaId) => {
        let link = ["city=" + cityId, "cinema=" + cinemaId, "date=" + date];
        this.props.history.push("reports-download?" + link.join("&"));
    };

    updateLink(newParams) {
        const { filters: { dateBegin, dateEnd, ...stateFitlers } } = this.state;
        const filters = Object.assign({}, stateFitlers);
        const params = Object.assign(filters, newParams);
        if (!params.dateBegin && dateBegin) {
            Object.assign(params, { dateBegin: DateFormat.ddmmyyyy(dateBegin) });
        }
        if (!params.dateEnd && dateEnd) {
            Object.assign(params, { dateEnd: DateFormat.ddmmyyyy(dateEnd) });
        }
        const body = Object.entries(params).reduce(
            (prev, [key, value]) =>
                (value && Object.assign(prev, { [key]: value })) || prev,
            {}
        );
        const stringParams = encodeBody(body, null, false);
        this.props.history.push(`reports-summary${stringParams && "?" + stringParams}`);
    }

    render() {
        const { reportGroup, isNoticeVisible } = this.state;
        const dateRange = this.getDateRanges();
        const dates = this.getDates();
        let topContent = '';
        if (!reportGroup.length && isNoticeVisible) {
            topContent = (
                <div className="notice-block">
                    <div className="notice-block__icon">i</div>
                    <div className="notice-block__description">
                        Для просмотра сводки необходимо выбрать кинотеатр и даты.<br />
                        При выборе города отобразится сводка по всем кинотеатрам в этом городе.
              </div>
                    <button onClick={() => (this.setState({ isNoticeVisible: false }))} className="notice-block__hide" >Скрыть</button>
                </div>
            );
        }
        return (
            <Fragment>
                <h1 className="office-h1">Сводка по отчетам</h1>
                {topContent}
                <div className="office-filters">
                    <div className="office-filters__half custom-datepicker__group">
                        <label htmlFor="session-datepicker" className="custom-datepicker__label">День начала/окончания</label>
                        <DateRange
                            input
                            dateBegin={(dates[0] && new Date(dates[0])) || null}
                            dateEnd={(dates[1] && new Date(dates[1])) || null}
                            onChange={this.dateRangeFilterOnChange}
                            className="custom-datepicker__input"
                        />
                        <img src="/images/icon-calendar.png" alt="" className="custom-datepicker__icon" />
                    </div>
                </div>
                <SummaryList
                    reportGroup={reportGroup}
                    dateRange={dateRange}
                />
            </Fragment>
        );
    }
}

export default withRouter(connect(mapStateToProps)(ReportsSummary));



// WEBPACK FOOTER //
// ./src/containers/summary/user.jsx